export default "__VITE_ASSET__BGmNpDSl__"